(ns hai.entity.staging
  "The chip shapes a composer's picks show as while their save is in flight:
   a picked tag / contact / linked note / linked task patched onto the cached
   entity so the card shows it before the response carries the real thing.")

(defn tag-chip
  "The chip shape a picked tag shows as while its save is in flight. A tag
   typed fresh has no uuid until the server makes one; its name carries the
   chip until the response reconciles. A saved tag keeps its permissions, so
   a composer re-seeded from the patch still knows which ✕ to offer."
  [tag]
  (cond-> {:group/uuid (:group/uuid tag)
           :group/display-name (or (:group/display-name tag) (:tag/name tag))}
    (:tag/name tag) (assoc :tag/name (:tag/name tag))
    (:user.entity/permissions tag) (assoc :user.entity/permissions (:user.entity/permissions tag))))

(defn reconcile-tags
  "The staged tags with every name-only chip resolved against the tags the
   entity already carries. A tag typed fresh stays `{:tag/name …}` in the
   composer after its save lands; once the entity carries a tag by that name
   the chip is that tag — not a new one to create, nor a reason to detach the
   real one."
  [entity-tags tags]
  (let [by-name (into {} (map (juxt :group/display-name identity)) entity-tags)]
    (mapv (fn [tag]
            (if (:group/uuid tag)
              tag
              (or (get by-name (:tag/name tag)) tag)))
          tags)))

(defn contact-chip
  [contact]
  (select-keys contact [:contact/uuid :contact/full-name :contact/organisation?]))

(defn note-chip
  [note]
  (select-keys note [:note/uuid :note/text]))

(defn task-chip
  [task]
  (select-keys task [:task/uuid :task/title]))
